import * as yup from 'yup';

export const FibuAccountStationarySchema = yup.object({
  careCostsGrade1Pz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade1Pk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade1Bh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade1Sa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade2Pz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade2Pk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade2Bh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade2Sa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade3Pz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade3Pk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade3Bh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade3Sa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade4Pz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade4Pk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade4Bh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade4Sa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade5Pz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade5Pk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade5Bh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsGrade5Sa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  uvCosts: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  uCosts: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  vCosts: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careCostsAdditional: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  careAidsAdditional: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  uvCostsAdditional: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  investmentCosts: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  investmentCostsSa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  surcharge43bCostsPk: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  surcharge43bCostsBh: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  surcharge43bCostsPz: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  surcharge43bCostsSa: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  otherCosts: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  remuneration: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
  cashAmount: yup.object().shape({
    itemId: yup.string().nullable().notRequired(),
    costCenter: yup.string().nullable().notRequired(),
  }),
});
export interface IFibuAccountConfigItem {
  itemId?: string | null;
  costCenter?: string | null;
}
export interface IFibuAccountStationary {
  careCostsGrade1Pz: IFibuAccountConfigItem;
  careCostsGrade1Pk: IFibuAccountConfigItem;
  careCostsGrade1Bh: IFibuAccountConfigItem;
  careCostsGrade1Sa: IFibuAccountConfigItem;
  careCostsGrade2Pz: IFibuAccountConfigItem;
  careCostsGrade2Pk: IFibuAccountConfigItem;
  careCostsGrade2Bh: IFibuAccountConfigItem;
  careCostsGrade2Sa: IFibuAccountConfigItem;
  careCostsGrade3Pz: IFibuAccountConfigItem;
  careCostsGrade3Pk: IFibuAccountConfigItem;
  careCostsGrade3Bh: IFibuAccountConfigItem;
  careCostsGrade3Sa: IFibuAccountConfigItem;
  careCostsGrade4Pz: IFibuAccountConfigItem;
  careCostsGrade4Pk: IFibuAccountConfigItem;
  careCostsGrade4Bh: IFibuAccountConfigItem;
  careCostsGrade4Sa: IFibuAccountConfigItem;
  careCostsGrade5Pz: IFibuAccountConfigItem;
  careCostsGrade5Pk: IFibuAccountConfigItem;
  careCostsGrade5Bh: IFibuAccountConfigItem;
  careCostsGrade5Sa: IFibuAccountConfigItem;
  uvCosts: IFibuAccountConfigItem;
  uCosts: IFibuAccountConfigItem;
  vCosts: IFibuAccountConfigItem;
  careCostsAdditional: IFibuAccountConfigItem;
  uvCostsAdditional: IFibuAccountConfigItem;
  careAidsAdditional: IFibuAccountConfigItem;
  investmentCosts: IFibuAccountConfigItem;
  investmentCostsSa: IFibuAccountConfigItem;
  surcharge43bCostsPk: IFibuAccountConfigItem;
  surcharge43bCostsBh: IFibuAccountConfigItem;
  surcharge43bCostsPz: IFibuAccountConfigItem;
  surcharge43bCostsSa: IFibuAccountConfigItem;
  otherCosts: IFibuAccountConfigItem;
  remuneration: IFibuAccountConfigItem;
  cashAmount: IFibuAccountConfigItem;
}
